import { useEffect } from 'react'
import { Link } from 'react-router-dom';
import FooterContact from '../../../component/FooterContact';
import HomeVideo2 from '../../../assets/images/banner/banner-1.mp4';

export default function Endpoint() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Hero Banner */}
            <section className="pad60 box-shadow innertopbanner" style={{ position: 'relative', overflow: 'hidden' }}>
                <div className="overlay-top-left"></div>
                <div className="container">
                    <div className="row align-items-center height100">
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-caption">
                                <div itemScope itemType="http://schema.org/BreadcrumbList" className="breadcrumbs">
                                    <ul>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <Link to="/"><span itemProp="name">Home</span></Link>
                                            <meta itemProp="position" content="1" />
                                        </li>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <i className="icofont-thin-right"></i>
                                            <span itemProp="name">Endpoint Security</span>
                                            <meta itemProp="position" content="2" />
                                        </li>
                                    </ul>
                                </div>
                                <div className="prod-section-label">Endpoint Protection</div>
                                <h1 className="prod-hero-title">Complete <span>Endpoint Security</span> for the Modern Enterprise</h1>
                                <p>Endpoint security is a cybersecurity strategy focused on safeguarding desktops, laptops, and mobile devices from malicious threats and activities — wherever your workforce operates.</p>
                                <div className="button_services mt-4">
                                    <Link to="/contact"><button className="prod-cta-btn">Contact Us &nbsp;<i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-12">
                            <div className="banner-mobiles text-center">
                                <img src={require('../../../assets/images/services/products/data-bg-transparant.webp')} alt="Endpoint Security" />
                            </div>
                        </div>
                    </div>
                </div>
                <video autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
            </section>

            {/* Stats */}
            <section style={{ background: '#0a0a0a', padding: '0 0 20px' }}>
                <div className="container">
                    <div className="prod-stats-row">
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">$4.45M</div>
                            <div className="prod-stat-label">Avg. Cost of Data Breach</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">73%</div>
                            <div className="prod-stat-label">SMBs Hit by Cyberattack</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">22%</div>
                            <div className="prod-stat-label">Remote Workforce by 2025</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">200+</div>
                            <div className="prod-stat-label">Adversaries Tracked</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* What is Endpoint Security */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/endpoint-1.jpg')} alt="Endpoint Security" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Overview</div>
                                <h2>What is Endpoint Security?</h2>
                                <p>An Endpoint Protection Platform (EPP) detects and blocks threats such as file-based malware attacks and other malicious activities. It provides tools for investigating and remediating security incidents.</p>
                                <p>Endpoints include: Laptops, Tablets, Mobile devices, IoT devices, Point-of-sale systems, Switches, and Digital printers — all potential entry points for attackers.</p>
                                <p>Every remote endpoint can be a potential entry point for an attack, and the number of endpoints continues to grow with the shift toward remote work.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Benefits */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Benefits</div>
                        <h2 className="prod-section-title">Endpoint Security <span>Benefits</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Comprehensive protection that empowers your business to operate securely at scale</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-shield"></i></div>
                            <h4>Endpoint Protection</h4>
                            <p>As digital transformation pushes more employees to work remotely, protecting all endpoints has become essential to prevent breaches and data loss.</p>
                            <div className="prod-feature-number">01</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-user-secret"></i></div>
                            <h4>Identity Protection</h4>
                            <p>Protects employees and stakeholders' sensitive data by ensuring only authorized users have the right type of access to the right resources.</p>
                            <div className="prod-feature-number">02</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-search"></i></div>
                            <h4>Threat Detection &amp; Response</h4>
                            <p>Quickly detecting potential threats accelerates remediation and ensures that data remains protected against sophisticated cyberattacks.</p>
                            <div className="prod-feature-number">03</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Core Functionality */}
            <section className="prod-dark-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Core Functionality</div>
                        <h2 className="prod-section-title">Four Pillars of <span>Endpoint Protection</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Endpoint security tools that offer continuous breach prevention must incorporate these fundamental elements</p>
                    </div>
                    <div className="prod-numbered-list">
                        <div className="prod-step-item">
                            <span className="prod-step-num">01</span>
                            <div>
                                <h4>Prevention: NGAV (Next-Generation Antivirus)</h4>
                                <p>Traditional antivirus detects fewer than half of all attacks. NGAV bridges the gap by leveraging AI and machine learning to detect new malware, analyzing file hashes, URLs, and IP addresses — not just known signatures.</p>
                            </div>
                        </div>
                        <div className="prod-step-item">
                            <span className="prod-step-num">02</span>
                            <div>
                                <h4>Detection: EDR (Endpoint Detection &amp; Response)</h4>
                                <p>An EDR solution provides continuous, real-time visibility into endpoint activity with advanced threat detection, investigation, incident data search, alert triage, suspicious activity validation, and threat hunting.</p>
                            </div>
                        </div>
                        <div className="prod-step-item">
                            <span className="prod-step-num">03</span>
                            <div>
                                <h4>Managed Threat Hunting</h4>
                                <p>Elite security teams analyze past incidents, aggregate crowdsourced data, and offer guidance on the best responses when malicious activity is detected, proactively identifying threats missed by automated systems.</p>
                            </div>
                        </div>
                        <div className="prod-step-item">
                            <span className="prod-step-num">04</span>
                            <div>
                                <h4>Threat Intelligence Integration</h4>
                                <p>Real-time, accurate intelligence with automation to swiftly investigate incidents in minutes. Generates custom indicators of compromise (IOCs) directly from endpoints, enabling proactive defense against future attacks.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Key Advantages */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/tab-endpoint.webp')} alt="Endpoint Advantages" style={{ objectFit: 'contain', background: 'rgba(255,255,255,0.03)', borderRadius: 16 }} />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Why Choose Us</div>
                                <h2>Key Platform Advantages</h2>
                                <ul className="prod-benefits-list">
                                    <li><span className="ben-dot">✓</span>A single, lightweight agent that allows for simple scaling</li>
                                    <li><span className="ben-dot">✓</span>Machine learning — ability to learn from new attacks</li>
                                    <li><span className="ben-dot">✓</span>Enhanced manageability with real-time updates</li>
                                    <li><span className="ben-dot">✓</span>Protection on or off the network — no blind spots</li>
                                    <li><span className="ben-dot">✓</span>Monitor adversaries and understand their tactics and motivations</li>
                                </ul>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '24px', display: 'inline-flex' }}>
                                    Get Started <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section style={{ background: '#0a0a0a', padding: '0 0 80px' }}>
                <div className="container">
                    <div className="prod-cta-banner">
                        <div>
                            <h3>Secure Every Endpoint in Your Organization</h3>
                            <p>Get a customized endpoint security strategy tailored to your business size and threat landscape.</p>
                        </div>
                        <Link to="/contact" className="prod-cta-btn">
                            Talk to Experts <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                        </Link>
                    </div>
                </div>
            </section>

            <FooterContact />
        </>
    )
}
